<template>
  <footer class="footer-custom">
    <div class="container-fluid px-md-5">
      <div class="row align-items-center mb-5 border-bottom border-secondary pb-5">
        <div class="col-lg-7">
          <h2 class="display-4 fw-black text-white mb-0">The Apex Mx</h2>
          <p class="motto-accent text-uppercase">El estándar en protección táctica</p>
        </div>
        <div class="col-lg-5 text-lg-end">
          <p class="footer-manifesto">
            "No one is coming to save you." <br>
            <span class="text-secondary small">Prepárate para ser el primero en responder.</span>
          </p>
        </div>
      </div>

      <div class="row py-4">
        <div class="col-md-12">
          <nav class="footer-nav-wrap">

            <div class="nav-group">
              <span class="nav-label">EQUIPAMIENTO</span>
              <RouterLink to="/shop">Ropa</RouterLink>
              <RouterLink to="/shop">Equipo</RouterLink>
              <RouterLink to="/shop">Accesorios</RouterLink>
            </div>

            <div class="nav-group">
              <span class="nav-label">ENTRENAMIENTO</span>
              <RouterLink to="/live-training">Eventos Presenciales</RouterLink>
              <RouterLink to="/virtual-training">Academia Online</RouterLink>
            </div>

            <div class="nav-group">
              <span class="nav-label">EMPRESA</span>
              <RouterLink to="/about-us">Nuestra Historia</RouterLink>
              <RouterLink to="/contact">Contáctanos</RouterLink>
            </div>

          </nav>
        </div>
      </div>


      <div class="row align-items-end pt-2">
        <div class="col-lg-4 mb-4 mb-lg-0" />

        <div class="col-lg-4 text-center mb-4 mb-lg-0">
          <div class="social-circles">
            <a href="#"><img :src="iconosRedes['youtube']" alt="youtube" /></a>
            <a href="#"><img :src="iconosRedes['instagram']" alt="instagram" /></a>
            <a href="#"><img :src="iconosRedes['facebook']" alt="facebook" /></a>
          </div>
        </div>

        <div class="col-lg-4 text-lg-end">
          <div class="legal-credits">
            <p class="mb-0">© 2026 The Apex Mx. All Rights Reserved.</p>
            <p class="coudera-tag">
              Engineered by <a href="https://coudera.com" target="_blank">COUDERA.COM</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import youtubeIcon from "@/assets/img/Evolve/youtube.png";
import facebookIcon from "@/assets/img/Evolve/facebook.png";
import instagramIcon from "@/assets/img/Evolve/instagram.png";
import twitterIcon from "@/assets/img/Evolve/twitter.png";

const iconosRedes = {
  youtube: youtubeIcon,
  facebook: facebookIcon,
  instagram: instagramIcon,
  twitter: twitterIcon,
};
export default {
  name: "Footer",
  data() {
    return {
      iconosRedes,
    };
  },
};

</script>

<style scoped>
.footer-custom {
  background-color: #080808;
  /* Casi negro absoluto */
  color: #e0e0e0;
  padding: 60px 0 40px 0;
  border-top: 4px solid #ff3131;
}

.fw-black {
  font-weight: 900;
}

.motto-accent {
  color: #ff3131;
  letter-spacing: 5px;
  font-weight: 700;
  font-size: 0.9rem;
}

.footer-manifesto {
  font-size: 1.2rem;
  font-weight: 300;
  font-style: italic;
}

/* Navegación Horizontal No Convencional */
.footer-nav-wrap {
  display: flex;
  flex-wrap: wrap;
  gap: 50px;
}

.nav-group {
  display: flex;
  flex-direction: column;
}

.nav-label {
  font-size: 0.7rem;
  font-weight: 800;
  color: #ff3131;
  margin-bottom: 15px;
  letter-spacing: 2px;
}

.nav-group a {
  color: #fff;
  text-decoration: none;
  font-size: 1.1rem;
  margin-bottom: 5px;
  transition: 0.3s;
  font-weight: 500;
}

.nav-group a:hover {
  color: #ff3131;
  transform: skewX(-10deg);
  /* Efecto agresivo/táctico */
}

/* Newsletter Minimalista */
.form-control-minimal {
  background: transparent;
  border: none;
  border-bottom: 1px solid #444;
  color: #fff;
  padding: 10px 0;
  width: 80%;
}

.btn-minimal-arrow {
  background: transparent;
  border: none;
  border-bottom: 1px solid #444;
  color: #ff3131;
  font-size: 1.5rem;
}

/* Social */
/* Social circles - Contenedor <a> */
.social-circles a {
  display: inline-flex;
  width: 45px;
  height: 45px;
  border: 1px solid #333;
  border-radius: 50%;
  align-items: center;
  justify-content: center;
  margin: 0 10px;
  transition: 0.3s;
  overflow: hidden;
  /* Asegura que nada se salga del círculo */
  padding: 0;
  /* Elimina cualquier padding heredado */
}

/* Ajuste de las Imágenes */
.social-circles a img {
  width: 45px;
  /* Aumentado de 20px para que se vea más proporcional */
  height: 45px;
  object-fit: contain;
  /* Mantiene la proporción del icono sin deformarlo */
  transition: 0.3s;
}

.social-circles a:hover {
  /* agregamos una sombra */
  box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);
}

/* Opcional: Si quieres que el icono cambie ligeramente al hacer hover */
.social-circles a:hover img {
  transform: scale(1.1);
  filter: brightness(1.2);
}

/* Legal & Coudera */
.legal-credits {
  font-size: 0.8rem;
  color: #666;
}

.coudera-tag {
  margin-top: 5px;
}

.coudera-tag a {
  color: #fff;
  font-weight: 900;
  text-decoration: none;
  letter-spacing: 1px;
}

.coudera-tag a:hover {
  color: #ff3131;
}

@media (max-width: 991px) {
  .footer-nav-wrap {
    gap: 30px;
  }

  .footer-custom {
    padding: 60px 0 30px 0;
  }
}
</style>